module.exports = __webpack_public_path__ + "img/idCode2.c4d3377d.png";